import Typography from "antd/lib/typography";
import clsx from "clsx";
import { ReactNode } from "react";

type Props = {
    id?: string;
    className?: string;
    children: ReactNode;
};

export const FollowUpTitle = ({ className, children, id }: Props) => {
    return (
        <div className={clsx("flex flex-col items-start justify-center", className)}>
            <Typography.Text className="text-ant-h2 font-ant-strong" id={id}>
                {children}
            </Typography.Text>
        </div>
    );
};
